import { WordingMultiAstrologyMeditationLove } from '@/types';

export const MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_PL: WordingMultiAstrologyMeditationLove = {
  components_header_media_content: 'Astrologia',
  components_header_media_multi_content_2: 'Medytacja',
  components_header_media_multi_content_3: 'Miłość',
  components_header_text1: 'Przewodniki',
  components_header_text2: 'Blog',
  hero_text: 'Znajdź jasność, równowagę i połączenie.',
  hero_button_text: 'Rozpocznij swoją podróż',
  components_ressources_subheader_text: 'Porady i inspiracje',
  components_ressources_span_text: 'Łączy w sobie osobiste spostrzeżenia astrologiczne, uspokajające praktyki medytacyjne i przemyślane wskazówki dotyczące miłości, aby wspierać samopoznanie, równowagę emocjonalną i głębszą więź.',
  components_ressources_card_1_title: 'Wskazówki dotyczące medytacji',
  components_ressources_card_1_text: 'Krótki przewodnik pozwalający uzyskać lepszy spokój, oddech i koncentrację.',
  components_ressources_card_2_title: 'Miłosne przewodnictwo',
  components_ressources_card_2_text: 'Proste wskazówki, jak zbudować silniejszą więź i równowagę emocjonalną.',
  components_ressources_link: 'Odkryj więcej',
  components_notes_and_google_title_1: 'Znajdź jasność',
  components_notes_and_google_title_2: 'Wewnętrzny spokój',
  components_notes_and_google_title_3: 'Połączenie serca',
  media_content_section_multi_1_subheader_text: 'Nasz podcast',
  media_content_section_multi_2_subheader_text: 'Nasze medytacje',
  media_content_section_multi_3_subheader_text: 'Prawdziwa rozmowa o kosmicznym romansie',
  page_media_content_menu_antistress: 'Antystresowy',
  page_media_content_menu_mindfulness: 'Uważność',
  page_media_content_menu_energyboost: 'Zastrzyk energii',
  page_media_content_menu_mantra: 'Mantra',
  page_media_content_menu_foundations: 'Podwaliny',
  page_media_content_menu_spirituality: 'Duchowość',
  page_media_content_menu_tarot: 'Tarot',
  page_media_content_menu_psychology: 'Psychologia',
  page_media_content_menu_trends: 'Trendy',
  page_media_content_menu_compatibility: 'Zgodność',
  page_media_content_menu_love: 'Miłość',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Artykuły i spostrzeżenia',
  text2_section_button_more: 'Załaduj więcej',
  components_text1_section_title: 'PRZEWODNIKI',
  components_text1_subheader_text: 'Wiedza kosmiczna dla codziennego wyrównania',
  components_text1_span_text: 'Dostosuj się do rytmów wszechświata: zapoznaj się z starannie dobraną kolekcją dogłębnych przewodników astrologicznych i medytacyjnych, które mają na celu przebudzenie wewnętrznej jasności, pogłębienie samoświadomości i wsparcie Twojej podróży ku duchowemu, niebiańskiemu rozwojowi.',
  components_text1_card_1_title: 'Otwórz się na ciszę',
  components_text1_card_1_text: 'Rozpocznij swoją podróż z podstawowymi przewodnikami po medytacji i astrologii — idealnymi dla osób poszukujących wewnętrznej ciszy, wzorców kosmicznych i osobistego wglądu.',
  components_text1_card_3_title: 'Połączenie umysłu i ciała',
  components_text1_card_3_text: 'Odkryj głębsze warstwy swojego wewnętrznego świata. Te przewodniki wykraczają poza powierzchnię, aby ujawnić znaczenie, emocje i uważne wzorce, które kształtują Twoje doświadczenie.',
  components_text1_card_2_title: 'Odzwierciedlaj i integruj',
  components_text1_card_2_text: 'Od blokad emocjonalnych po cykle planetarne — te przewodniki oferują narzędzia do refleksji, uzdrawiania i transformacji poprzez uważne rytuały i mądrość astrologiczną.',
  components_text1_link: 'Zobacz wszystkie przewodniki',
  components_footer_text: 'Znajdź jasność, zrównoważ swój umysł i połącz się ze znaczeniem – to twoje miejsce na astrologię, medytację i miłość.',
};